export default "__VITE_ASSET__BqWFKiHo__"